export const TILES_DATA = [
  {
    categoryUrl: '/paintings',
    categoryName: 'Paintings',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/plp/painting.jpg',
  },
  {
    categoryUrl: '/photography',
    categoryName: 'Photography',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/plp/photography.jpg',
  },
  {
    categoryUrl: '/sculpture',
    categoryName: 'Sculpture',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/plp/sculpture.jpg',
  },
  {
    categoryUrl: '/drawings',
    categoryName: 'Drawings',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/plp/drawing.jpg',
  },
  {
    categoryUrl: '/prints',
    categoryName: 'Fine Art Prints',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/plp/print.jpg',
  },
  {
    categoryUrl: '/all/abstract',
    categoryName: 'Abstract Art',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/plp/abstract.jpg',
  },
]
